export default __webpack_public_path__ + "static/media/500.8858daa9.png";